import { Box, Typography } from "@mui/material";
import moment, { locale } from "moment";
import * as React from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { useDispatch, useSelector } from "react-redux";
import Collection from "./Collection";
import "./style.css";
import { useCollection } from "./useCollection";
import Loader from "../../../../components/Loader";

const NavigationLabel = ({ date, locale, label, view }) => {
  return (
    <>
      <Typography
      style={{
        fontWeight:"bold",
        fontSize:"1rem"
      }}
        sx={{
          textTransform: "Capitalize",
        }}
        variant="h2"
        color={"text.primary"}
      >
        {label}
      </Typography>
      <Typography
      variant="h3"
      style={{
        fontSize:"0.9rem"
      }}>
        Hoje é dia {new Date().toLocaleDateString(locale)}
      </Typography>
    </>
  );
};

const TitleContent = ({ date, view, collectionDate }) => {
  const collectDate = !!collectionDate.find(
    (item) => new Date(item).getDate() === new Date(date).getDate()
  );

  const color = React.useMemo(() => {
    if (view === "month" && collectDate === true) {
      return "#1b727e";
    }
    return "transparent";
  }, [view, collectionDate]);

  return (
    <Typography
      fontSize={"24px"}
      fontWeight={"bold"}
      sx={{ color: color, lineHeight: 0, p: 1 }}
    >
      .
    </Typography>
  );
};

const ActionDate = ({ collectionDetails, t }) => {
  const {
    loading,
    allCollectionDetail,
    collectionDate,
    setMonthStartDate,
    setMonthEndDate,
    dateState,
    setDateState,
    particularDateCollection,
  } = useCollection();

  React.useEffect(() => {
    const currentDate = new Date();
    const firstDate = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      1
    );
    const lastDate = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth() + 1,
      1
    );
    setMonthStartDate(moment(firstDate).format("YYYY-MM-DD"));
    setMonthEndDate(moment(lastDate).format("YYYY-MM-DD"));
  }, []);

  const renderWeekdayShort = (locale, date) => {
    const options = { weekday: 'short'};
    return date.toLocaleDateString(locale, options)[0];
  };
  
  return (
    <>
      <Box>
        <Calendar
          tileContent={({ date, view }) => (
            <TitleContent
              date={date}
              view={view}
              collectionDate={collectionDate}
            />
          )}
          // minDetail="month"
          // maxDetail="month"
          showNeighboringMonth={false}
          navigationLabel={({ date, locale, label, view }) => (
            <NavigationLabel
              date={date}
              locale={locale}
              label={label}
              view={view}
            />
          )}
          onChange={(value, e) => {
            setDateState(value);
          }}
          onActiveStartDateChange={({ activeStartDate }) => {
            setMonthStartDate(moment(activeStartDate).format("YYYY-MM-DD"));
            setMonthEndDate(
              moment(activeStartDate).endOf("month").add(1).format("YYYY-MM-DD")
            );
          }}
          value={dateState}
          locale="pt-PT"
          formatShortWeekday={renderWeekdayShort}
        />
        {loading && <Loader t={t} />}
        {!loading && (
          <Collection
            collectionDetails={collectionDetails}
            allCollectionDetail={particularDateCollection}
            t={t}
          />
        )}
      </Box>
    </>
  );
};

export default ActionDate;
